<template>
  <van-tabs v-model="active" swipeable color="#07C160" sticky>
    <van-tab title="设备信息"><div class="divider" /><device-info /></van-tab>
    <van-tab title="设备设置"><div class="divider" /><device-setting /></van-tab>
    <van-tab title="设备指令"><div class="divider" /><device-order /></van-tab>
  </van-tabs>
</template>

<script>
import {Tabs, Tab, Divider} from 'vant';
import DeviceSetting from "@/view/setting/index_enjiaaier"
import DeviceOrder from "@/view/order/index"
import DeviceInfo from "@/view/device/info/index"
import {setToken} from "@/util/auth";
import {setImei, setSaasId} from "@/util/session-storage-utils";
export default {
  name: "device-index-enjiaaier",
  components:{
    [Tabs.name]:Tabs,
    [Tab.name]:Tab,
    [DeviceSetting.name]:DeviceSetting,
    [DeviceOrder.name]:DeviceOrder,
    [DeviceInfo.name]:DeviceInfo,
    [Divider.name]:Divider
  },
  data(){
    return {
      active:1
    };
  },
  created(){
    setToken(this.$route.query._token)
    let imei = this.$route.query._imei;
    setImei(imei)
    let saasId = this.$route.query._saasId;
    setSaasId(saasId)
    this.active = parseInt(this.$route.query.tabActive)
    // this.loadData();
  },
}
</script>

<style scoped>
.divider{
  height: 10px;
}
</style>
